import { Component, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import TileWMS from 'ol/source/TileWMS';
import { fromLonLat } from 'ol/proj';
import { WindowComponent } from 'movisat-common-gui';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-plugin-map',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    WindowComponent,
  ],
  templateUrl: './plugin-map.component.html',
  styleUrl: './plugin-map.component.css',
})
export class PluginMapComponent implements AfterViewInit {
  @ViewChild('mapWindow') public mapWindow: WindowComponent;
  @ViewChild('mapContainer', { static: false }) public mapContainer!: ElementRef;
  private wmsLayer!: TileLayer;
  private map!: Map;
  public static _this: PluginMapComponent;

  public userWmsUrl: string = '';
  public capabilities: any[] = [];
  public selectedLayer: string = '';

  public constructor(private http: HttpClient) {}

  public ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    this.wmsLayer = new TileLayer({
      source: new TileWMS({
        url: '',
        params: {
          'LAYERS': '',
          'FORMAT': 'image/png',
          'TRANSPARENT': 'true'
        }
      })
    });

    this.map = new Map({
      target: this.mapContainer.nativeElement,
      layers: [
        new TileLayer({
          source: new OSM()
        }),
        this.wmsLayer
      ],
      view: new View({
        center: fromLonLat([-3.7038, 40.4168]),
        zoom: 10
      })
    });
  }

  public fetchCapabilities(): void {
    if (!this.userWmsUrl) {
      console.warn('Introduce una URL');
      return;
    }
    const capabilitiesUrl = `${this.userWmsUrl}?service=WMS&version=1.3.0&request=GetCapabilities`;
    this.http.get(capabilitiesUrl, { responseType: 'text' })
      .subscribe(response => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response, "application/xml");
        // Extraemos todos los nodos <Layer> que contengan un <Name>
        const layerNodes = xmlDoc.getElementsByTagName("Layer");
        let layers: any[] = [];
        for (let i = 0; i < layerNodes.length; i++) {
          const nameNode = layerNodes[i].getElementsByTagName("Name")[0];
          const titleNode = layerNodes[i].getElementsByTagName("Title")[0];
          if (nameNode && titleNode) {
            layers.push({
              name: nameNode.textContent,
              title: titleNode.textContent
            });
          }
        }
        this.capabilities = layers;
      }, error => {
        console.error("Error al obtener capacidades", error);
        alert("Error al obtener las capacidades del WMS");
      });
  }

  public updateWmsLayer(): void {
    if (this.userWmsUrl && this.selectedLayer) {
      const baseUrl = this.userWmsUrl.split('?')[0];
      const newSource = new TileWMS({
        url: baseUrl,
        params: {
          'VERSION': '1.3.0',
          'LAYERS': this.selectedLayer,
          'FORMAT': 'image/png',
          'TRANSPARENT': 'true',
          'CRS': 'EPSG:3857'
        }
      });
      this.wmsLayer.setSource(newSource);
    } else {
      alert("Debes introducir la URL y seleccionar una capa");
    }
  }

  public translate(text: string): string {
    return AppComponent.translate(text);
  }
}
